import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 12 12"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 8V5.5M6.25 4a.25.25 0 0 1-.5 0m.5 0a.25.25 0 0 0-.5 0m.5 0h-.5M11 6A5 5 0 1 1 1 6a5 5 0 0 1 10 0Z"
    />
  </svg>
)
export default SvgComponent
